export default __webpack_public_path__ + "static/media/connection-visibility-set-on.eaa414df.svg";